// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dayToScheduleGroup article.tableBox .listTable table tbody tr td{font-weight:400}.tableTitle{padding-left:5px}@media screen and (max-width:1000px){.dailyScheduleFontSize{font-size:13px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
